import { Component, inject } from '@angular/core';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { SidepanelService } from '../sidepanel.service';

@Component({
  selector: 'app-button-close-panel',
  imports: [HlmButtonImports],
  template: '<button hlmBtn variant="secondary" class="w-full" (click)="closeSidepanel()">Fermer le panneau</button>',
})
export class ButtonClosePanelComponent {
  readonly #sidepanelService = inject(SidepanelService);

  closeSidepanel() {
    this.#sidepanelService.close();
  }
}
